import "bootstrap/dist/css/bootstrap.min.css"
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "bootstrap"
import {createApp, ref} from 'vue'
import App from './App'
import router from './router'
import i18n from './translation'

import {library} from "@fortawesome/fontawesome-svg-core";

import {faPhone} from "@fortawesome/free-solid-svg-icons";

library.add(faPhone);

import {fas} from '@fortawesome/free-solid-svg-icons'

library.add(fas);

import {fab} from '@fortawesome/free-brands-svg-icons';

library.add(fab);

import {far} from '@fortawesome/free-regular-svg-icons';

library.add(far);

import {dom} from "@fortawesome/fontawesome-svg-core";

dom.watch();


import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

import CountryFlag from 'vue-country-flag-next'
import globalHoverFix, { HoverFixPlugin } from './utils/globalHoverFix.js'


function detectColorScheme() {
    let theme = 'light';
    if (localStorage.getItem('theme')) {
        if (localStorage.getItem('theme') === "dark") {
            theme = 'dark';
        }
    } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        theme = 'dark';
    }
    if (theme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
        return true;
    }
    return false;
}

const app = createApp(App);

app.config.devtools = true

app.provide('isDark', ref(detectColorScheme()))
    .component('font-awesome-icon', FontAwesomeIcon)
    .use(CountryFlag)
    .use(i18n)
    .use(router)
    // .use(HoverFixPlugin)
    .mount('#app')
